<div class="app-classroom-participants" *ngIf="classroom$ | async as classroom">
  <section class="participants-section">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-3">
          <button class="back-button text-capitalize" (click)="backPrevious()">
            <img class="arrow-back" alt="back" />
            {{ 'classroom.action_buttons.back' |  transloco }}
          </button>
        </div>

        <div class="col-12 col-md-12 col-lg-9">
          <div class="participants-wrapper">
            <div class="row">
              <div class="col-12 col-md-12 col-lg-8">
                <div class="section">
                  <div class="header-section">
                    <h3 class="h3">{{ 'classroom.titles.payment' | transloco }}</h3>
                    <h4 class="h4">{{ classroom.title }}</h4>
                  </div>
                  <div class="header-section">
                    <h4 class="h4">{{ 'classroom.titles.date' | transloco }}</h4>
                    <h5 class="h5">
                      {{ getSchedule(classroom).startDate | date: 'yyyy-dd-MM' }} -
                      {{ getSchedule(classroom).endDate | date: 'yyyy-dd-MM' }}
                    </h5>
                  </div>
                </div>

                <div class="section">
                  <div class="header-section">
                    <h4 class="h4">{{ 'classroom.titles.participants_number' | transloco }}</h4>
                    <h5 class="h5">{{ params.participant }}</h5>
                  </div>
                </div>

                <form [formGroup]="participantForm" (ngSubmit)="saveParticipants()">
                  <ng-container formArrayName="participants">
                    <h4 class="customer-info">{{ 'classroom.titles.customer_info' | transloco }}</h4>

                    <ng-container
                      *ngFor="let participantGroup of participants.controls; let i = index; let isFirst = first"
                    >
                      <h3 class="form-group-title">{{ 'classroom.titles.participant' | transloco }} {{ i + 1 }}</h3>

                      <div class="my-4" [formGroup]="convertToGroup(participantGroup)">
                        <div class="form-group">
                          <div *ngIf="isFirst" class="custom-checkbox">
                            <input
                              [formControl]="selfParticipant"
                              (change)="checkSelfParticipant(convertToGroup(participantGroup))"
                              type="checkbox"
                              class="custom-control-input"
                              id="self-booking"
                              name="self-booking"/>
                            <label class="custom-control-label" for="self-booking">
                              {{ 'classroom.self_participant' | transloco }}
                            </label>
                          </div>
                        </div>

                        <div class="form-group">
                          <label class="text-uppercase control-label">
                            {{ 'classroom.participant_form.labels.phone' | transloco }}
                          </label>
                          <div class="row">
                            <div class="col-12 col-md-12">
                              <div class="input-group">
                                <ng-select class="input-group-prepend phone-code" [searchable]="false" formControlName="phonePrefix" [clearable]="false" (change)="checkParticipantIdentity(participantGroup)">
                                  <ng-option *ngFor="let country of countryList$ | async"
                                             [value]="country.phonePrefix">
                                    {{country.twoLetterISOCode + '(' + country.phonePrefix + ')'}}
                                  </ng-option>
                                </ng-select>
                                <input
                                  type="text"
                                  formControlName="phone"
                                  (blur)="checkParticipantIdentity(participantGroup)"
                                  class="form-control rounded-0"
                                  placeholder="{{ 'classroom.participant_form.placeholders.phone' | transloco }}"
                                  required
                                />
                              </div>

                              <div class="phone-help-text">
                                {{ 'classroom.participant_form.participant_phone_help_message' | transloco }}
                              </div>
                              <ng-container *ngTemplateOutlet="formGroupError; context:{ $implicit: 'phone', control: participantGroup.get('phone')}"></ng-container>
                            </div>
                          </div>
                        </div>

                        <div class="form-group">
                          <label class="text-uppercase control-label">
                            {{ 'classroom.participant_form.labels.name' | transloco }}
                          </label>
                          <div class="row">
                            <div class="col-12 col-md-12">
                              <input
                                type="text"
                                formControlName="name"
                                class="form-control rounded-0"
                                placeholder="{{ 'classroom.participant_form.placeholders.name' | transloco }}"
                                required/>
                              <ng-container *ngTemplateOutlet="formGroupError; context:{ $implicit: 'name', control: participantGroup.get('name')}"></ng-container>
                            </div>
                          </div>
                        </div>



                        <div class="form-group">
                          <label class="text-uppercase control-label">
                            {{ 'classroom.participant_form.labels.email' | transloco }}
                          </label>
                          <div class="row">
                            <div class="col-12 col-md-12">
                              <input
                                type="text"
                                formControlName="email"
                                (blur)="validateEmail(convertToGroup(participantGroup))"
                                class="form-control rounded-0"
                                placeholder="{{ 'classroom.participant_form.placeholders.email' | transloco }}"
                                required
                              />
                              <div class="phone-help-text" *ngIf="!(isFirst && selfParticipant.value)">
                                {{ 'classroom.participant_form.participant_email_help_message' | transloco }}
                              </div>
                              <div class="text-danger"
                                   *ngIf="participantGroup.get('isInvalidEmail').value &&
                                   participantGroup.get('email').valid"
                              >
                                {{ emailSuggestion ?? 'classroom.participant_form.validations.email.email' | transloco }}
                              </div>
                              <ng-container *ngTemplateOutlet="formGroupError; context:{ $implicit: 'email', control: participantGroup.get('email')}"></ng-container>
                            </div>
                          </div>
                        </div>

                      </div>
                    </ng-container>
                  </ng-container>
                  <button type="submit" [disabled]="participantForm.invalid" class="btn btn-primary">
                    {{ 'classroom.participant_form.submit_form' | transloco }}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<ng-template #formGroupError let-formControlName let-formcontrol="control">
  <div *ngIf="formcontrol.touched && formcontrol.errors" class="text-danger" >
    <ng-container *ngIf="formcontrol?.errors?.required">
      {{ 'classroom.participant_form.validations.'+formControlName+'.required'  | transloco }}
    </ng-container>
    <ng-container *ngIf="!(formcontrol?.errors?.pattern) && (formcontrol?.errors?.invalidPhoneNumberLength)">
      {{ 'classroom.participant_form.validations.'+formControlName+'.length'  | transloco }}
    </ng-container>
    <ng-container *ngIf="formcontrol?.errors?.pattern">
      {{ 'classroom.participant_form.validations.'+formControlName+'.pattern'  | transloco }}
    </ng-container>
    <ng-container *ngIf="formcontrol?.errors?.email">
      {{  'classroom.participant_form.validations.'+formControlName+'.email'  | transloco }}
    </ng-container>
  </div>
</ng-template>
